import GlobalForm from "../GlobalForm";
import React, { useState } from 'react';
import EmailBox from "../../ui-components/EmailBox";
import InputBox from "../../ui-components/InputBox";
import SelectDropdown from "../../ui-components/SelectDropdown";
import DatePickerRange from "../../ui-components/DatePickerRange";
import CustomSearchInputBox from "../../ui-components/CustomSearchInputBox";
import CustomCheckBox from "../../ui-components/CustomCheckBox";
import {
  Box,
  Typography,
  Alert,
  RadioGroup,
  FormControl,
  FormControlLabel,
  styled,
  Radio,
  InputBase,
  Switch,
  TextField, Paper, MenuItem, Select
} from "@mui/material"
import { useDispatch, useSelector } from "react-redux";
import DatePickerSingle from "../../ui-components/DatePickerSingle";
import { Button } from "@mui/material";
import MultiSelectDropdown from "../../ui-components/MultiSelectDropdown";
import CustomMultiSelectDrop from "../../ui-components/CustomMultiSelectDrop";
import ReportStruct from "./ReportStruct";
import { recordDateArray } from "../../../redux/slices/routeSlice";
import ErrorMsg from "./ErrorMsg";
import moment from "moment";
import Filter from '../../Filter/Filter'
import {TimePicker} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import { useTranslation } from 'react-i18next';

const StyledFormControlLabel = styled(FormControlLabel)(() => ({
  minWidth: '311px',
  margin: '0 0 4px 0',
  height: '40px',
  background: '#FAFAFA',
  border: '0.5px solid #CCCCCC',
  borderRadius: '2px',

  '& .MuiRadio-root.Mui-checked' : {
    color: "#2e7d32"
  }
}))
let scheduledReportTime = moment().local(true).set({ hour: 10, minute: 0, second: 0, millisecond: 0 }).toISOString();

export default function ReportContent() {
  const route = useSelector((state) => state.route)
  const rerun = route?.activeItem?.rerun || false;
  const rc = route?.activeItem?.rerunConfig
  let set = new Date();
  let localISOTime = set.getFullYear() + '-' + ( set.getMonth() + 1) + '-' + set.getDate();
  return (
    <GlobalForm
      initialValues={{
        date_range_option: {key: null, value: null},
        date_range: { range_date_start: null, range_date_end: null },
        checkSearch: "",
        projection_fields: new ReportStruct(true, []),
        filters: {
          suppliers: new ReportStruct(true, []),
          manufacturers: new ReportStruct(true, []),
          category: new ReportStruct(true, []),
          clinic: new ReportStruct(true, []),
          serviceEquipments: { include: false },
          pds_include_annual_gl_codes: { include: false },
          offCatalogOnly: { include: false },
        },
        custom_field_filters:{
          operation:'AND',
          condition:[],
        },
        report_format: 'csv',
        email: rerun && rc.email || [],
        scheduleFrequency: {},
        report_type: route.modalShow.report_type,
        //first_delivery_date: moment().utcOffset(0).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toISOString(),
        first_delivery_date: localISOTime,
        timezone_offset: new Date().getTimezoneOffset(),
        title: rerun && rc.title || '',
        date_filter: '',
        preferred_delivery_time: scheduledReportTime,
        sftp_path_prefix: ''
        // frequencyOption: [],
        // scheduleStartingDate: null,
      }}
    >
      <Form />
    </GlobalForm>
  );
}

const reconcileProjectionFieldsOnRerun = (rerun, allFields, rerunFields) => {
  if (!rerun) {
    return allFields
  }
  const fields = []
  for (const field of allFields) {
    let found = rerunFields.find(f => f.key === field.key)
    const f = {...field}
    if (!f.required && !found) {
      f.unselected = true
    } else {
      delete f.unselected
    }
    fields.push(f)
  }
  return fields
}

const completeDateRange = (initialDateRange, scheduleValue, t) => {
  const newRange = [];
  newRange.push(...initialDateRange);
  newRange.push({ key: -2, value: t('report.filter.date.mtd')})
  newRange.push({ key: -4, value: t('report.filter.date.previousMonth')})
  newRange.push({ key: -3, value: t('report.filter.date.ytd')})
  if( scheduleValue === 'AD_HOC') {
    newRange.push({ key: -1, value: t('report.filter.date.customRange') })
  }
  return newRange
}

const Form = (props) => {
  const route = useSelector((state) => state.route)
  const rerun = route?.activeItem?.rerun || false;
  const rc = route?.activeItem?.rerunConfig;
  const form = useSelector((state) => state.form)
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const reportType = route.modalShow.report_type;
  const [scheduleValue, setScheduleValue] = useState(reportType);
  const [filterItems, setFilterItems] = useState([]);
  let item = {...route.activeItem};
  item.fields = reconcileProjectionFieldsOnRerun(rerun, route.activeItem.fields, rc?.projection_fields?.selected)
  const dateArr = item.filters.filter(item => (item.type === "date_range"))
  const completeRange = completeDateRange(dateArr?.[0]?.values || [], reportType, t)
  const idx = completeRange.findIndex(r => rc?.date_range_option?.key === +r.key)
  const [allSupplierFlag, setAllSupplierFlag] = useState(rc?.filters?.suppliers?.all ?? true);
  const [allManufacturerFlag, setAllManufacturerFlag] = useState(true);
  const [allClinicFlag, setAllClinicFlag] = useState(true);
  const [allCategoryFlag, setAllCategoryFlag] = useState(true);
  const [allEquipmentFlag,setAllEquipmentFlag] = useState(false);
  const [includeAnnualGLCodes, setIncludeAnnualGLCodes] = useState(false);
  const [offCatalogOnlyFlag,setOffCatalogOnlyFlag] = useState(false);
  const [sftpReportFlag,setSftpReportFlag] = useState(false);
  const [reportFormatFlag,setReportFormatFlag] = useState(rerun && rc?.report_format || 'csv');
  const [preferredDeliveryTime, setPreferredDeliveryTime] = useState(scheduledReportTime);
  const [dateFilterValue, setDateFilterValue] = useState("");
    const [reportActionFilterValue, setReportActionFilterValue] = useState("");
  const [accountingDateFilterValue, setAccountingDateFilterValue] = useState("");
  const [dateRangeSelection, setDateRangeSelection] = useState(idx>=0 ? idx : dateArr?.[0]?.default || 0);
  const FrequencyOptions = [
    {
      key: 1,
      value: t('report.schedule.frequency.daily'),
      label: 'DAILY'
    },
    {
      key: 7,
      value: t('report.schedule.frequency.weekly'),
      label: 'WEEKLY'
    },
    {
      key: 14,
      value: t('report.schedule.frequency.biweekly'),
      label: 'BIWEEKLY'
    },
    {
      key: 30,
      value: t('report.schedule.frequency.monthly'),
      label: 'MONTHLY'
    },
    {
      key: 91,
      value: t('report.schedule.frequency.quarterly'),
      label: 'QUARTERLY'
    },
    {
      key: 182,
      value: t('report.schedule.frequency.semiannually'),
      label: 'SEMI-ANNUALLY'
    },
    {
      key: 365,
      value: t('report.schedule.frequency.annually'),
      label: 'ANNUALLY'
    }
  ]

  const handleChange = (event) => {
    setScheduleValue(event.target.value);
    props.formikProps.setFieldValue('report_type', event.target.value);
  };

  const handleDateFilterChange = (event) => {
    setDateFilterValue(event.target.value);
    props?.formikProps.setFieldValue('date_filter', event.target.value)
  };

  const handleReportActionFilterChange = (event) => {
    setReportActionFilterValue(event.target.value);
    props?.formikProps.setFieldValue('report_action', event.target.value)
  };

  const handleAccountingDateFilterChange = (date) => {
    if (date) {
      const dt = moment(date)
        .utc(true)
        .utcOffset(0)
        .set({hour: 0, minute: 0, second: 0, millisecond: 0})
        .format('YYYY/MM/DD');
      setAccountingDateFilterValue(dt);
      props?.formikProps.setFieldValue('accounting_date', dt)
    } else {
      setAccountingDateFilterValue('');
      props?.formikProps.setFieldValue('accounting_date', undefined)
    }
  };

  React.useEffect(() => {
      const projection_fields =  props.formikProps.values["projection_fields"]; 
      projection_fields.selected = filterItems;
      projection_fields.all = ( item.fields.length === filterItems.length )
  }, [filterItems])

  const CustomSelect = styled(Select)`
    & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: none;
    }

    & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
      border-color: none;
    }

    & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input {
      background-color: none;
      border-color: none;
    }
  `;

  const setRange = (data) => {
    let start = null, end = null;
    start = moment().subtract(Number(data?.key) | 1, 'd').utcOffset(0).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toISOString();
    if (start != null) {
      end = moment().utcOffset(0).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toISOString();
      props.formikProps.setFieldValue('date_range', {
        range_date_start: start, range_date_end: end
      })
    }
  }

  const populateConfigOnRerun = () => {
    const rc = route.activeItem.rerunConfig
    const df = route.activeItem.filters.find((i) => i.type === "date_filter")
    const dr = route.activeItem.filters.find((i) => i.type === "date_range")
    const dateFilter = rc?.date_filter || df?.values?.[0]?.key
    props.formikProps.setFieldValue('filters', {
      suppliers: new ReportStruct(rc?.filters?.suppliers?.all ?? true, rc?.filters?.suppliers?.selected ?? []),
      manufacturers: new ReportStruct(rc?.filters?.manufacturers?.all ?? true, rc?.filters?.manufacturers?.selected ?? []),
      category: new ReportStruct(rc?.filters?.category?.all ?? true, rc?.filters?.category?.selected ?? []),
      clinic: new ReportStruct(rc?.filters?.clinic?.all ?? true, rc?.filters?.clinic?.selected ?? []),
      serviceEquipments: { include: rc?.filters?.serviceEquipments?.include ?? false},
      pds_include_annual_gl_codes: {include: rc?.filters?.pds_include_annual_gl_codes?.include ?? false},
      offCatalogOnly: { include: rc?.filters?.offCatalogOnly?.include ?? false},
    })
    props.formikProps.setFieldValue('date_filter', dateFilter)
    props.formikProps.setFieldValue('report_format', rc?.report_format)
    props.formikProps.values["date_range_option_subtype"] = dr?.subType ?? 'day';
    props.formikProps.values["date_range"] = { range_date_start: rc?.date_range?.range_date_start ?? null, range_date_end: rc?.date_range?.range_date_end ?? null }
    setFilterItems(item.fields?.filter((field) => !field?.unselected))
    setAllSupplierFlag(rc?.filters?.suppliers?.all ?? true)
    setAllManufacturerFlag(rc?.filters?.manufacturers?.all ?? true)
    setAllClinicFlag(rc?.filters?.clinic?.all ?? true)
    setAllCategoryFlag(rc?.filters?.category?.all ?? true)
    setAllEquipmentFlag(rc?.filters?.serviceEquipments?.include ?? false)
    setIncludeAnnualGLCodes(rc?.filters?.pds_include_annual_gl_codes?.include ?? false)
    setOffCatalogOnlyFlag(rc?.filters?.offCatalogOnly?.include ?? false)
    setDateFilterValue(dateFilter)
    const reportAction = rc?.report_action || route.activeItem.filters.find((i) => i.type === "report_action")?.values?.[0]?.key
    setReportActionFilterValue(reportAction)
  }

  // Resetting form data on reroute
  React.useEffect(() => {

    if (route.activeItem?.rerun) {
      populateConfigOnRerun()
      return
    }

    setFilterItems(route.activeItem?.fields?.filter((field) => !field?.unselected));
    props.formikProps.values["projection_fields"].selected = filterItems;
    const dateRange = route.activeItem.filters.filter((i) => i.type === "date_range")
    const dateFilter = route.activeItem.filters.filter((i) => i.type === "date_filter")
    props.formikProps.values["date_range_option"] = dateRange?.[0]?.values[dateRange?.[0]?.default];
    props.formikProps.values["date_range_option_subtype"] = dateRange?.[0]?.subType ?? 'day';
    props.formikProps.values["custom_field_filters"] = {
      operation:'AND',
      condition:[],
    };
    if (dateRange.length === 1) {
      updateDateArray(dateRange?.[0]?.values)
    }
    setRange(dateRange?.[0]?.values[dateRange?.[0]?.default])
    // props.formikProps.values['filters'] = {
    //   suppliers: new ReportStruct(true, []),
    //   manufacturers: new ReportStruct(true, []),
    //   category: new ReportStruct(true, []),
    //   clinic: new ReportStruct(true, [])
    // }

    // Resetting filter values
    props.formikProps.setFieldValue('filters', {
      suppliers: new ReportStruct(true, []),
      manufacturers: new ReportStruct(true, []),
      category: new ReportStruct(true, []),
      clinic: new ReportStruct(true, []),
	    serviceEquipments: { include: false},
      pds_include_annual_gl_codes: {include: false},
      offCatalogOnly: { include: false},
    })
    props.formikProps.values['email'] = [];
    // schedule_frequency: ''
    props.formikProps.values['report_type'] = reportType;
    props?.formikProps.setFieldValue('date_filter', dateFilter[0]?.values[0]?.key)
    setScheduleValue(reportType);
    // Resetting switch toggle form value
    setAllCategoryFlag(true);
    setAllClinicFlag(true);
    setAllManufacturerFlag(true);
    setAllSupplierFlag(true);
    setDateFilterValue(dateFilter[0]?.values[0]?.key)
    const reportAction = route.activeItem.filters.filter((i) => i.type === "report_action")
    if (reportAction.length > 0) {
      props?.formikProps.setFieldValue('report_action', reportAction[0]?.values[0]?.key)
      setReportActionFilterValue(reportAction[0]?.values[0]?.key)
    }

  }, [route.activeItem])


  const handleFilterChange = (selectedConditions,selectedOperation) => {
    const conditions = []
    for (const selectedCondition of selectedConditions) {
      if (selectedCondition.fieldId !== " " && selectedCondition.operator !== " ") {
        conditions.push(selectedCondition)
      }
    }
    props.formikProps.setFieldValue('custom_field_filters',{condition:conditions, operation:selectedOperation || "AND"})
  };

  const updateDateArray = (data) => {
    const newRange = completeDateRange(data, scheduleValue, t)
    dispatch(recordDateArray(newRange));
  }

  React.useEffect(() => {
    if (dateArr.length === 1) {
        updateDateArray(dateArr[0].values)
    }
  }, [scheduleValue])


  //   React.useEffect(() => {
  //   if (dateArr.length === 1) {
  //     if (scheduleValue == 0) {
  //       let arr_v = Object.assign([], dateArr[0].values);
  //       arr_v.push({ key: 'custom_range', value: 'Custom Range' })
  //       dispatch(recordDateArray(arr_v));
  //     } else {
  //       dispatch(recordDateArray(dateArr[0].values));
  //     }
  //   }
  // }, [scheduleValue])

  const toggleAllSelectionSwitch = (tag) => {
    switch (tag){
      case 'suppliers':
        setAllSupplierFlag(!allSupplierFlag);
        break;
      case 'manufacturers':
        setAllManufacturerFlag(!allManufacturerFlag);
        break;
      case 'clinic':
        setAllClinicFlag(!allClinicFlag);
        break;
      case 'category':
        setAllCategoryFlag(!allCategoryFlag);
        break;
      case 'serviceEquipments': {
        setAllEquipmentFlag(!allEquipmentFlag);
        props?.formikProps.setFieldValue('filters[serviceEquipments]',{ include: !allEquipmentFlag })
      }
      break;
      case 'pds_include_annual_gl_codes':
        setIncludeAnnualGLCodes(!includeAnnualGLCodes);
        props?.formikProps.setFieldValue('filters[pds_include_annual_gl_codes]', {include: !includeAnnualGLCodes})
        break;
      case 'reportFormat':
        if (reportFormatFlag === 'xlsx') {
            setReportFormatFlag('csv');
            props?.formikProps.setFieldValue('report_format', 'csv')
        } else {
            setReportFormatFlag('xlsx');
            props?.formikProps.setFieldValue('report_format', 'xlsx')
        }
        break;
      case 'offCatalogOnly': {
        setOffCatalogOnlyFlag(!offCatalogOnlyFlag);
        props?.formikProps.setFieldValue('filters[offCatalogOnly]',{ include: !offCatalogOnlyFlag })
      }
      break;
      case 'sftpReport': {
        setSftpReportFlag(!sftpReportFlag);
        props?.formikProps.setFieldValue('sftp_report', !sftpReportFlag)

      }
      break
      default:
        break;
    }
  }

  return (
    <Box sx={{maxHeight: '70vh',height: '100%',overflowY: 'auto', overflowX: 'hidden'}}>
      <Box sx={{
        padding: '12px 16px 0 32px',
        borderRadius: '0',
        background: '#fff'
      }}>
        <Box sx={{ mt: '40px' }}>
          <Typography variant="reportDisplayRoboto" component="div" >{item?.title}</Typography>
          <Typography variant="reportTitleTextRoboto" component="div" sx={{ mt: '8px' }}>{item?.desc}</Typography>
          {item?.dataSource && <Typography variant="reportTitleTextRoboto" component="div" sx={{ mt: '8px', fontSize: '12px', fontStyle: 'italic', fontWeight: '' }}>Data Source: {item?.dataSource}</Typography>}
        </Box>
            <Box sx={{}}>
              <Typography variant="reportTitle" component="div" >{t('report.name')}</Typography>
        <InputBox
          sx={{ width: '397px' }}
          tag={"title"}
          formikProps={props?.formikProps}
          label={t('report.name')}
        />
        <ErrorMsg formikProps={props.formikProps} tag={"title"} />
        </Box>

        <Box sx={{display: 'flex', alignItems: 'center', marginTop: '20px'}}>
          <Typography variant="reportFormat">{t('report.format')}</Typography>
          <FormControl sx={{paddingLeft: '10px', background: '#ededed', marginLeft: '10px', borderRadius: '20px'}}>
            <RadioGroup
                row
                defaultValue="csv"
                name="report-format-radio-buttons-group"
            >
              <FormControlLabel value="csv" control={<Radio checked={reportFormatFlag === "csv"}
                                                            onChange={() => toggleAllSelectionSwitch('reportFormat')}
                                                            color="success"/>} label={<Typography style={{fontSize: '14px', fontWeight: '500'}}>{t('common.csv')}</Typography>}  />
              <FormControlLabel value="xlsx" control={<Radio checked={reportFormatFlag === "xlsx"}
                                                             onChange={() => toggleAllSelectionSwitch('reportFormat')}
                                                             color="success"/>} label={<Typography style={{fontSize: '14px', fontWeight: '500'}}>{t('common.xlsx')}</Typography>} />
            </RadioGroup>
          </FormControl>
        </Box>


        {item?.filters && item.filters.map((v, filter_index) => {
          var fields = [];

          // CLINIC
          if (v.type === "clinic") {
            fields.push(<div key={filter_index}>
                                          <Box sx={{display: 'flex', alignItems: 'baseline'}}>

              <Typography variant="reportTitle" component="div" >{t('report.forOfficeLocation')}</Typography>

              <FormControl sx={{paddingLeft: '10px', background: '#ededed', marginLeft: '10px', borderRadius: '20px'}}>
                <FormControlLabel
                  control={
                    <Switch checked={allClinicFlag} onChange={() => toggleAllSelectionSwitch('clinic')} name="allSupplier" color="success" />
                  }
                  label={<Typography style={{ fontSize: '14px', fontWeight: '500' }}>{t('common.all')}</Typography>}
                />
              </FormControl>
              </Box>
              <MultiSelectDropdown allFlag={allClinicFlag} tag={"clinic"} formikProps={props?.formikProps} options={form.clinic} rerunOptions={rc?.filters?.clinic?.selected ?? []}/>
              <ErrorMsg formikProps={props.formikProps} tag={"clinic"} />
            </div>)
          }

          // Service/Equipment
          if (v.type === "serviceEquipments") {
            fields.push(<div key={filter_index}>
                                          <Box sx={{display: 'flex', alignItems: 'baseline'}}>

              <Typography variant="reportTitle" component="div" >{t('report.includeServiceEquipments')}</Typography>

              <FormControl sx={{paddingLeft: '10px', background: '#ededed', marginLeft: '10px', borderRadius: '20px'}}>
                <FormControlLabel
                  control={
                    <Switch checked={props?.formikProps.values['filters']['serviceEquipments'].include} onChange={() => toggleAllSelectionSwitch('serviceEquipments')} name="allServiceEquipment" color="success" />
                  }
                />
              </FormControl>
              </Box>
              <ErrorMsg formikProps={props.formikProps} tag={"serviceEquipments"} />
            </div>)
          }

          // PDS Include gl code
          if (v.type === "pds_include_annual_gl_codes") {
            fields.push(<div key={filter_index}>
                                          <Box sx={{display: 'flex', alignItems: 'baseline'}}>

              <Typography variant="reportTitle" component="div" >{t('report.includeGLCodes')}</Typography>

              <FormControl sx={{paddingLeft: '10px', background: '#ededed', marginLeft: '10px', borderRadius: '20px'}}>
                <FormControlLabel
                  control={
                    <Switch checked={props?.formikProps.values['filters']['pds_include_annual_gl_codes'].include} onChange={() => toggleAllSelectionSwitch('pds_include_annual_gl_codes')} name="includeAnnualGLCodes" color="success" />
                  }
                />
              </FormControl>
              </Box>
              <ErrorMsg formikProps={props.formikProps} tag={"pds_include_annual_gl_codes"} />
            </div>)
          }

          // off-catalog-only
          if (v.type === "offCatalogOnly") {
            fields.push(<div key={filter_index}>
              <Box sx={{display: 'flex', alignItems: 'baseline'}}>

                <Typography variant="reportTitle" component="div" >Include Off-Catalog Items Only:</Typography>

                <FormControl sx={{paddingLeft: '10px', background: '#ededed', marginLeft: '10px', borderRadius: '20px'}}>
                  <FormControlLabel
                    control={
                      <Switch checked={props?.formikProps.values['filters']['offCatalogOnly'].include} onChange={() => toggleAllSelectionSwitch('offCatalogOnly')} name="offCatalogOnly" color="success" />
                    }
                  />
                </FormControl>
              </Box>
              <ErrorMsg formikProps={props.formikProps} tag={"offCatalogOnly"} />
            </div>)
          }

          // SUPPLIER 
          if (v.type === "supplier") {
            //   if (v.type === "suppliers" && form.suppliers.length > 0) {
            fields.push(<div key={filter_index}>
                                          <Box sx={{display: 'flex', alignItems: 'baseline'}}>

              <Typography variant="reportTitle" component="div" >{t('report.selectSuppliers')}</Typography>

              <FormControl sx={{paddingLeft: '10px', background: '#ededed', marginLeft: '10px', borderRadius: '20px'}}>
                <FormControlLabel
                  control={
                    <Switch checked={allSupplierFlag} onChange={() => toggleAllSelectionSwitch('suppliers')} name="allSupplier" color="success" />
                  }
                  label={<Typography style={{ fontSize: '14px', fontWeight: '500' }}>{t('common.all')}</Typography>}
                />
              </FormControl>
              </Box>
              <CustomMultiSelectDrop allFlag={allSupplierFlag} tag={"suppliers"} formikProps={props?.formikProps} _options={form.supplier} rerunOptions={rc?.filters?.suppliers?.selected ?? []} />
              <ErrorMsg formikProps={props.formikProps} tag={"suppliers"} />
            </div>)
          }

          // CATEGORY
          if (v.type === "category") {
            //   if (v.type === "category" && form.category.length > 0) {
            fields.push(<div key={filter_index}>
                            <Box sx={{display: 'flex', alignItems: 'baseline'}}>

              <Typography variant="reportTitle" component="div" >{t('report.selectCategories')}</Typography>
              <FormControl sx={{paddingLeft: '10px', background: '#ededed', marginLeft: '10px', borderRadius: '20px'}}>
                <FormControlLabel
                  control={
                    <Switch checked={allCategoryFlag} onChange={() => toggleAllSelectionSwitch('category')} name="allSupplier" color="success" />
                  }
                  label={<Typography style={{ fontSize: '14px', fontWeight: '500' }}>{t('common.all')}</Typography>}
                />
              </FormControl>
              </Box>
              <MultiSelectDropdown allFlag={allCategoryFlag} tag={"category"} formikProps={props?.formikProps} options={form.category} rerunOptions={rc?.filters?.category?.selected ?? []}/>
              <ErrorMsg formikProps={props.formikProps} tag={"category"} />
            </div>)
          }

          // MANUFACTURER
          if (v.type === "manufacturer") {
            //   if (v.type === "manufacturers" && form.manufacturers.length > 0) {
            fields.push(<div key={filter_index}>
              <Box sx={{display: 'flex', alignItems: 'baseline'}}>
              <Typography variant="reportTitle" component="div" >{t('report.selectManufacturers')}</Typography>
              <FormControl sx={{paddingLeft: '10px', background: '#ededed', marginLeft: '10px', borderRadius: '20px'}}>
                <FormControlLabel
                  control={
                    <Switch checked={allManufacturerFlag} onChange={() => toggleAllSelectionSwitch('manufacturers')} name="allManufacturer" color="success" />
                  }
                  label={<Typography style={{ fontSize: '14px', fontWeight: '500' }}>{t('common.all')}</Typography>}
                />
              </FormControl>
              </Box>
              <CustomMultiSelectDrop allFlag={allManufacturerFlag} tag={"manufacturers"} formikProps={props?.formikProps} _options={form.manufacturer} rerunOptions={rc?.filters?.manufacturers?.selected ?? []}/>

              <ErrorMsg formikProps={props.formikProps} tag={"manufacturers"} />
            </div>)
          }

          // DATE RANGE
          if (v.type === "date_range") {
            fields.push(<div key={filter_index}>
              <Typography variant="reportTitle" component="div" >{t('report.selectDateRange')}</Typography>

              <SelectDropdown
                tag={"date_range_option"}
                formikProps={props?.formikProps}
                placeholder={t('report.selectDateRange')}
                width={"248px"}
                fromSlice={true}
                default={dateRangeSelection}
              />
              <ErrorMsg formikProps={props.formikProps} tag={"date_range_option"} />

              {(props.formikProps.values.date_range_option?.key === -1) ? (
                <><DatePickerRange
                  tag={["range_date_start", "range_date_end"]}
                  view={props.formikProps.values.date_range_option_subtype}
                  formikProps={props?.formikProps}
                  label={["Start Date", "End Date"]}
                />
                  <ErrorMsg formikProps={props.formikProps} tag={"date_range"} />
                </>
              ) : ''}

            </div>)
          }
          if (v.type === "date_filter") {
            fields.push(<div key={filter_index}>
              <div
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    padding: "5px",
                    marginTop: "40px",
                  }}
              >
                <Typography
                    fontWeight={500}
                    fontSize={"16px"}
                    fontFamily={"Roboto!important"}
                >
                  {t('report.filter.date.title')}
                </Typography>
                <div style={{marginBottom: "10px"}}>
                  <div
                      style={{marginTop: "10px", display: "flex", gap: "10px"}}
                  >
                    <Box
                        sx={{width: '100%', display: 'table', clear: 'both'}}>
                      <Box sx={{width: '25%', float: 'left'}}>
                        <CustomSelect
                            value={dateFilterValue}
                            onChange={handleDateFilterChange}
                            style={{
                              width: "95%",
                              height: "40px",
                              borderRadius: "1px",
                              background: "#FAFAFA",
                              "&:hover": {
                                border: "none",
                              },
                              fontSize: "12px"
                            }}
                        >
                          {v.values.map((item, index) => {
                            return (
                                <MenuItem key={item.key} value={item.key}>
                                  {item.value}
                                </MenuItem>
                            )
                          })}
                        </CustomSelect>
                      </Box>
                    </Box>
                  </div>
                </div>
              </div>

            </div>)
          }
          if (v.type === "report_action") {
            fields.push(<div key={filter_index}>
              <div
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    padding: "5px",
                    marginTop: "20px",
                  }}
              >
                <Typography
                    fontWeight={500}
                    fontSize={"16px"}
                    fontFamily={"Roboto!important"}
                >
                  Action
                </Typography>
                <div style={{marginBottom: "10px"}}>
                  <div
                      style={{marginTop: "10px", display: "flex", gap: "10px"}}
                  >
                    <Box
                        sx={{width: '100%', display: 'table', clear: 'both'}}>
                      <Box sx={{width: '25%', float: 'left'}}>
                        <CustomSelect
                            value={reportActionFilterValue}
                            onChange={handleReportActionFilterChange}
                            style={{
                              width: "95%",
                              height: "40px",
                              borderRadius: "1px",
                              background: "#FAFAFA",
                              "&:hover": {
                                border: "none",
                              },
                              fontSize: "12px"
                            }}
                        >
                          {v.values.map((item, index) => {
                            return (
                                <MenuItem key={item.key} value={item.key}>
                                  {item.value}
                                </MenuItem>
                            )
                          })}
                        </CustomSelect>
                      </Box>
                    </Box>
                  </div>
                </div>
              </div>

            </div>)
          }
          if (v.type === "accounting_date") {
            fields.push(<div key={filter_index}>
              <div
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    padding: "5px",
                    marginTop: "20px",
                  }}
              >
                <Typography
                    fontWeight={500}
                    fontSize={"16px"}
                    fontFamily={"Roboto!important"}
                >
                  Accounting Date
                </Typography>
                <div style={{marginBottom: "10px"}}>
                  <div
                      style={{marginTop: "10px", display: "flex", gap: "10px"}}
                  >
                    <Box
                        sx={{width: '100%', display: 'table', clear: 'both'}}>
                      <Box sx={{width: '25%', float: 'left'}}>
                        <DatePickerSingle
                            tag={"accounting_date"}
                            formikProps={props?.formikProps}
                            label={"Accounting Date"}
                            value={accountingDateFilterValue}
                            onChange={handleAccountingDateFilterChange}
                            disablePast={false}
                            sx={{marginBottom: 0}}
                        />
                      </Box>
                    </Box>
                  </div>
                </div>
              </div>

            </div>)
          }
          return fields;
        })}

        {(item?.fields) ? (<>
          <Typography variant="reportTitle" component="div" >{t('report.selectDataYouWant')}</Typography>
          <CustomSearchInputBox
            tag={"checkSearch"}
            formikProps={props?.formikProps}
            placeholder={t('nav.searchPlaceholder')}
            debounced
          />
          <ErrorMsg formikProps={props.formikProps} tag={"projection_fields"} />
          <Box
            sx={{ maxWidth: '300px', width: '100%', display: 'table', clear: 'both' }}>
            {
              item.fields
                .filter((el) =>
                  el.value
                    .toLowerCase()
                    .startsWith(props.formikProps.values['checkSearch'].toLowerCase())
                )
                .map((el, index) => {
                  return (
                    <Box key={index + item.title} sx={{ width: '50%', float: 'left' }}>
                      <CustomCheckBox
                        sx={{ width: '50%', float: 'left' }}
                        label={el.value}
                        key={index + item.title}
                        onCheck={() =>
                          setFilterItems(filterItems => [...filterItems, el])
                        }
                        onUncheck={() => {
                          setFilterItems(filterItems => filterItems.filter((el1) => el1.value !== el.value))
                        }}
                        isChecked={(el.unselected) ? false : true}
                        disabled={(el.required) ? true : false}
                        value={el.value}
                      />
                    </Box>)
                })}
            {/* {
                populateFilteredComponent(
                  item?.fields,
                  "checkSearch",
                  "projection_fields"
                )
              } */}
            </Box></>) : ''}
            <Box>
              <Filter data={route.activeItem}
                      onFilterChange={handleFilterChange}
                />
            </Box>
            <Typography variant="reportDisplayRoboto" component="div" sx={{marginTop:'48px'}} >{t("report.whenHowReceive")}</Typography>
            <Typography variant="paragraphGrey" component="div" sx={{ mt: '8px',mb:'24px', maxWidth:'480px' }}>{t("report.whenHowReceiveHelper")}
            </Typography>
            <FormControl>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="report_type"
              id="report_type"
              value={scheduleValue}
              onChange={handleChange}
            >
              <StyledFormControlLabel value="AD_HOC" control={<Radio />} label={t('report.schedule.asap')} />
              <StyledFormControlLabel value="SCHEDULED" control={<Radio />} label={t('report.schedule.scheduled')} />
            </RadioGroup>
          </FormControl>
          { (scheduleValue === 'SCHEDULED' ) &&
              <Box sx={{ background: '#2e7d3230', display: 'flex', flexDirection: 'column', alignItems: 'left', padding: '20px', borderRadius: '10px', maxWidth: '311px', boxSizing:'border-box', marginTop: '10px' }}>
                <Box>
                  <Typography variant="reportTitle" component="div" sx={{marginTop: 0, width: '100%'}}>
                    {t('report.schedule.frequencyHelper')}
                  </Typography>
                  <SelectDropdown
                      tag={"scheduleFrequency"}
                      formikProps={props?.formikProps}
                      placeholder={t('report.schedule.frequencyHelper')}
                      width={"248px"}
                      options={FrequencyOptions}
                      default={FrequencyOptions[0]}
                  /></Box>
                <Box>
                  <Typography variant="reportTitle" component="div" sx={{marginTop: '10px !important', width: '100%'}}>
                    {t('report.schedule.firstDeliveryDate')}
                  </Typography>

                  <DatePickerSingle
                      tag={"first_delivery_date"}
                      formikProps={props?.formikProps}
                      label={"Start Date"}
                      sx={{marginBottom: 0}}
                  /></Box>
                <Box>
                  <Typography variant="reportTitle" component="div" sx={{marginTop: '10px !important', width: '100%'}}>{t('report.schedule.preferredDeliveryTime')}</Typography>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Paper
                        component=""
                        sx={{
                          m: '10px 0px 0px 0',
                          display: 'flex',
                          alignItems: 'center',
                          width: '248px',
                          height: 40,
                          boxShadow: 0,
                          border: "0.5px solid #CCCCCC",
                          background: '#FAFAFA',
                          borderRadius: '2px',
                        }}
                    >
                    <TimePicker
                        label="Preferred Delivery Time"
                        value={preferredDeliveryTime}
                        onChange={(newValue) => {
                          setPreferredDeliveryTime(newValue);
                          props?.formikProps.setFieldValue('preferred_delivery_time', newValue)
                        }}
                        views={['hours']}
                        width={"248px"}
                        renderInput={({ inputRef, inputProps, InputProps }) => (
                            <InputBase
                                ref={inputRef}
                                // type={"date"}
                                endAdornment={(
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 10 }}>
                                      {InputProps?.endAdornment}
                                    </div>
                                )}
                                sx={{ ml: 1, flex: 1, padding: '7px 5px', fontSize: '12px', fontWeight: '500' }}
                                id={props?.tag}
                                name={props?.tag}
                                variant="outlined"
                                value={props?.formikProps?.values.date_range[props.tag]}
                                onChange={props?.formikProps?.handleChange}
                                {...inputProps}
                                placeholder={props.placeholder}
                            />
                        )}
                    />
                    </Paper>
                  </LocalizationProvider>
                </Box>
                <Box sx={{marginTop: '10px !important'}}>
                  <Typography variant="reportTitle" component="div" sx={{width: '100%', display: 'inline', marginRight: '20px'}}>{t('report.schedule.sftp.helper')}</Typography>
                  <FormControl sx={{paddingLeft: '10px', background: '#ededed', marginLeft: '10px', borderRadius: '20px', display: 'contents'}}>
                    <FormControlLabel
                        control={
                          <Switch checked={props?.formikProps.values['sftp_report']} onChange={() => toggleAllSelectionSwitch('sftpReport')} name="sftp_report" color="success" />
                        }
                    />
                  </FormControl>
                </Box>
                { (sftpReportFlag === true ) && ( <>
                <Box sx={{marginTop: '10px !important'}}>
                  <Typography variant="reportTitle" component="div" sx={{width: '100%', display: 'inline', marginRight: '20px'}}>SFTP Host </Typography>
                  <InputBox
                      formikProps={props?.formikProps}
                      label={"SFTP Host"}
                      width={'90%'}
                      tag={'sftp_host'}
                  />
                </Box>
                <Box sx={{marginTop: '10px !important'}}>
                  <Typography variant="reportTitle" component="div" sx={{width: '100%', display: 'inline', marginRight: '20px'}}>SFTP Username </Typography>
                  <InputBox
                      formikProps={props?.formikProps}
                      label={"SFTP Username"}
                      width={'90%'}
                      tag={'sftp_username'}
                  />
                </Box>
                <Box sx={{marginTop: '10px !important'}}>
                  <Typography variant="reportTitle" component="div" sx={{width: '100%', display: 'inline', marginRight: '20px'}}>SFTP Password </Typography>
                  <InputBox
                      formikProps={props?.formikProps}
                      label={"SFTP Password"}
                      width={'90%'}
                      tag={'sftp_password'}
                  />
                </Box>
                <Box sx={{marginTop: '10px !important'}}>
                  <Typography variant="reportTitle" component="div" sx={{width: '100%', display: 'inline', marginRight: '20px'}}>Upload Path Prefix </Typography>
                  <InputBox
                      formikProps={props?.formikProps}
                      label={"Upload Path Prefix"}
                      width={'90%'}
                      tag={'sftp_path_prefix'}
                  />
                </Box>
                </>)
                }
              </Box>
          }

        <Typography variant="reportTitle" component="div" >{t('report.downloadLinkHelper')}</Typography>

        <EmailBox
          sx={{ width: '397px' }}
          tag={"email"}
          formikProps={props?.formikProps}
          label={"Email"}
        />
        <ErrorMsg formikProps={props.formikProps} tag={"email"} />

        <Typography variant="paragraphGrey" component="div" sx={{ mt: '8px', maxWidth: '320px' }}>{t('report.multipleEmailsHelper')}</Typography>
        {/* Checkbox filter */}

        {/* 
      <CustomSearchInputBox
        tag={"listSearch"}
        formikProps={props?.formikProps}
        placeholder={"Search Menu List"}
        // debounced
      />
      {populateFilteredComponent(COMPONENT_TYPE[1], listOption, "listSearch")} */}
        <Button label={"Submit Report"} type='submit' variant="contained" disableElevation color="success" sx={{ background: '#00AD6F', p: '20px 137px', marginTop: '48px', textTransform: 'none' }}>
          {t('nav.cta.generate')}
        </Button>
        {/* <MuiButtons label={"Submit Report"} /> */}
      </Box>
    </Box>
  );
};
